import { render, staticRenderFns } from "./AttachDashboard.vue?vue&type=template&id=1512fbbc&v-on-clickaway=cancel&"
import script from "./AttachDashboard.vue?vue&type=script&lang=ts&"
export * from "./AttachDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports